import { Component, Host, Prop, State, h, Element } from '@stencil/core'
import { type CobaltIcon } from '../cobalt-icon/cobalt-icon'

@Component({
  tag: 'cobalt-banner',
  styleUrl: 'cobalt-banner.css'
})
export class CobaltBanner {
  /**
   * This is the text which will appear inside the banner. It is **required**.
   */
  @Prop({ mutable: true }) message!: string
  /**
   * This is the title which will appear on top of the banner.
   */
  @Prop({ mutable: true }) headline?: string
  /**
   * Allows to change the status of the banner.
   */
  @Prop({ mutable: true }) status?: 'success' | 'warning' | 'error' | 'information' | 'neutral' = 'information'
  /**
   * Allows to inline the buttons with the content of the banner.
   */
  @Prop({ mutable: true }) inlineButtons?: boolean = false
  /**
   * Allows to add a custom icon on neutral status. Accept all icon names from `@pollux-docaposte/icon-library`.
   */
  @Prop({ mutable: true }) iconName?: CobaltIcon['name'] = undefined
  /**
   * Add a button to make the banner dismissable.
   */
  @Prop({ mutable: true }) dismissButton?: boolean = false
  /**
   * This is the label for the close button. It should be used if `dismissButton` is `true`.
   */
  @Prop({ mutable: true }) dismissButtonLabel?: string = 'Fermer'
  /**
   * Show or hide the banner.
   */
  @Prop({ mutable: true }) dismiss?: boolean = false
  /**
   * Manage the display of the banner internally.
   */
  @State() isDismissed?: boolean = false

  @Element() element: HTMLElement

  resizeIconButton(): void {
    if (!this.element.querySelector('core-icon-button')) return
    this.element.querySelector('core-icon-button').setAttribute('size', 'small')
  }

  componentWillLoad(): void {
    this.resizeIconButton()
  }

  componentDidRender(): void {
    this.resizeIconButton()
  }

  render(): any {
    return (
      <Host>
        <core-banner
          message={this.message}
          headline={this.headline}
          status={this.status}
          inlineButtons={this.inlineButtons}
          iconName={this.iconName}
          dismissButton={this.dismissButton}
          dismissButtonLabel={this.dismissButtonLabel}
          dismiss={this.dismiss}
        >
          <slot slot="buttons" name="buttons"></slot>
        </core-banner>
      </Host>
    )
  }
}
